import Nullstack from 'nullstack';
export default function IconMap({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-map",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("polyline", {
    points: "3 7 9 4 15 7 21 4 21 17 15 20 9 17 3 20 3 7"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "4",
    x2: "9",
    y2: "17"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "7",
    x2: "15",
    y2: "20"
  }), " ");
}